import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/repository/history", "documento": "invoices", "acceso": "sesion", "filas": ["029"], "cita": "prod:Areas/Invoices/Controllers/RepositoryController.cs:131"} satisfies RutaProd;
